import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { PermissionChecker } from "../services/permission-checker.service";

export const roleGuard: CanActivateFn = (route, state) => {
  const permissionChecker = inject(PermissionChecker);
  return permissionChecker.hasRole(route.data["role"]);
};
